export default __webpack_public_path__ + "static/Entenda0020-99dfa67b2e36ab893705a8b33d627f5a.jpg";